module.exports = __webpack_public_path__ + "static/media/okW.ff58b462.svg";